import OrganizationClient from "../lib/apiClients/roofSnapApiClient/organizationClient";
import { CALL_API } from "../middleware/api";
import {
    GET_ORGANIZATION_FAILURE,
    GET_ORGANIZATION_REQUEST,
    GET_ORGANIZATION_SUCCESS
} from "./actionTypes";

export const getOrganization = (id) => {
    const organizationClient = new OrganizationClient('v1');
    const request = organizationClient.getOrganizations;

    return {
        [CALL_API]: {
            types: [
                GET_ORGANIZATION_REQUEST,
                GET_ORGANIZATION_SUCCESS,
                GET_ORGANIZATION_FAILURE,
            ],
            request,
            params: {
                id
            }
        }
    };
};
